<ng-container>		
			<ngx-dropzone (change)="onSelect($event)" class="dropzone" *ngIf="!processing_recs && !reviewReady">
				<ngx-dropzone-label class="dropzone-label">Drop file, or click to upload!</ngx-dropzone-label>
				<ngx-dropzone-preview *ngFor="let f of files;" [removable]="true" (removed)="onRemove(f)">
					<ngx-dropzone-label class="overflow-auto ">{{ f.name }}</ngx-dropzone-label>
				</ngx-dropzone-preview>
			</ngx-dropzone>
			<div class="table table-responsive text-center" *ngIf="processing_recs">
				<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div> 
			<ng-container *ngIf="reviewReady">
			<button mat-stroked-button [disabled]="!requiredOk" color="primary" (click)="returnMap()"> Submit Mapping </button>
			<table class="styled-table">
			<tr>
			<th *ngFor="let col of uploaddata.headers">
				{{col}}
			</th>
			</tr>
			<tr>
			<td *ngFor="let col of uploaddata.headers">
				<mat-form-field appearance="outline">
				<mat-label>Select Map for {{col}}</mat-label>
				<mat-select [(ngModel)]="tablemap[col]" (ngModelChange)="checkMap()">
								<mat-option *ngFor="let map of uploadColumns" [value]="map.column">
									{{ map.label }} <span *ngIf="map.required"> * </span>
								</mat-option>
				</mat-select>
				</mat-form-field>
			</td>
			</tr>
			<tr *ngFor="let row of uploaddata.rows">
			<td *ngFor="let col of uploaddata.headers">
				{{ row[col] }}
			</td>
			</tr>
			</table>
			</ng-container>
</ng-container>